import { colors } from '@material-ui/core';
import { Label } from 'components';


interface IProps {
    isExtended: boolean
    isPreGolive: boolean
}

let RegistrationStatus = (props: IProps) => {
    return (
        <>
            {props.isExtended &&
                <Label shape="square" variant="contained" color={colors.green[600]}>Extended</Label>
            }
            {props.isExtended === false &&
                <Label shape="square" variant="contained" color={props.isPreGolive ? colors.red[600] : colors.green[600]}>
                    {props.isPreGolive ? 'Denied' : 'Extended possible Gray Market'}
                </Label>
            }
        </>
    )
}

export default RegistrationStatus;